<template>
  <v-dialog v-model="active" width="480" persistent>
    <v-card color="primary" class="rounded-sm" v-if="equipo">
      <v-card-title>
        <div class="text-h6">Editar equipo</div>
        <v-spacer></v-spacer>
        <v-btn icon color="error" @click="closeDialog()"><v-icon>mdi-window-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <v-text-field
                class="ui-form-field"
                label="Número"
                v-model="equipo.numero"
                rounded
                filled
                dense
                color="secondary"
                background-color="transparent"
              >
              </v-text-field>
              <v-menu
                v-model="menuFechaFabricacion"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    class="ui-form-field"
                    :value="fechaFabricacion"
                    label="Fecha de fabricación"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="transparent"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="equipo.fechaFabricacion" @input="menuFechaFabricacion = false"></v-date-picker>
              </v-menu>
              <v-menu
                v-model="menuAniosVigencia"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    class="ui-form-field"
                    :value="aniosVigencia"
                    label="Fecha de vigencia"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="transparent"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="equipo.aniosVigencia" @input="menuAniosVigencia = false"></v-date-picker>
              </v-menu>
              <v-select
                class="ui-form-field"
                v-model="equipo.fk_idCatitem"
                rounded
                filled
                dense
                color="secondary"
                background-color="transparent"
                :items="items"
                item-value="id"
                item-text="item"
              >
                <template v-slot:label>Tipo de item <span class="red--text">*</span> </template>
              </v-select>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="justify-center ui-module-actions">
        <v-btn class="ui-module-btn-solid" :loading="loading" :disabled="loading" @click="triggerUpdateEquipo()"
          >Editar equipo</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    active: {
      type: Boolean,
    },

    equipo: {
      type: Object,
    },
  },

  data() {
    return {
      menuFechaFabricacion: false,
      menuAniosVigencia: false,
      loading: false,
    }
  },

  computed: {
    ...mapGetters('item', {
      items: 'getItems',
    }),

    fechaFabricacion: function () {
      return this.equipo.fechaFabricacion ? moment(this.equipo.fechaFabricacion).format(this.API_DATE_FORMAT) : ''
    },

    aniosVigencia: function () {
      return this.equipo.aniosVigencia ? moment(this.equipo.aniosVigencia).format(this.API_DATE_FORMAT) : ''
    },
  },

  methods: {
    ...mapActions('equipo', ['fetchEquipo', 'updateEquipo']),

    closeDialog() {
      this.$emit('close')
      this.loading = false
    },

    async triggerUpdateEquipo() {
      this.loading = true
      await this.updateEquipo(this.equipo)
      await this.fetchEquipo()

      this.closeDialog()
    },
  },
}
</script>

<style scoped>
::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(255, 159, 67, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  transition: all 0.3s ease !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(255, 159, 67, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input,
::v-deep .ui-form-field .v-select__selection,
::v-deep .ui-form-field .mdi-menu-down,
::v-deep .ui-form-field .mdi-calendar {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label,
::v-deep .ui-form-field .v-label--active {
  color: #ffbe76 !important;
}

::v-deep .ui-module-actions .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  min-width: 168px;
  transition: all 0.3s ease;
}

::v-deep .ui-module-actions .ui-module-btn-solid {
  background: linear-gradient(135deg, #ff9f43 0%, #ffbe76 100%) !important;
  color: #1f1305 !important;
  box-shadow: 0 8px 24px rgba(255, 159, 67, 0.28) !important;
}

::v-deep .ui-module-actions .v-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 159, 67, 0.25) !important;
}
</style>
